var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"ui-svg-icon transition-colors",style:(_vm.getIconStyles())})
}
var staticRenderFns = []

export { render, staticRenderFns }